import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "house",
  "use": "house-usage",
  "viewBox": "0 -0.032 17 16.644",
  "content": "<symbol viewBox=\"0 -0.032 17 16.644\" id=\"house\"><path d=\"M16.007 16.611h-4.195a.993.993 0 0 1-.993-.992v-4.196a1 1 0 0 0-1.006-.993H7.188a1 1 0 0 0-1.006.993v4.196a.993.993 0 0 1-.993.992H.993A.996.996 0 0 1 0 15.613V6.792c0-.551.366-1.265.815-1.591L7.685.205c.437-.316 1.196-.315 1.63 0l6.869 4.996c.45.326.816 1.04.816 1.591v8.821a.996.996 0 0 1-.993.998zM7.188 9.43h2.625c1.106 0 2.006.895 2.006 1.993v4.196L16 15.611V6.792c0-.229-.215-.646-.403-.783L8.728 1.013c-.073-.054-.38-.054-.455 0l-6.87 4.996c-.192.14-.403.55-.403.783v8.821l4.188-.002-.007-4.188A2.003 2.003 0 0 1 7.188 9.43z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/house.svg
// module id = 168
// module chunks = 0